import React, { useState } from "react";
import { Button, Card, Select, Spin, message } from "antd";
import { Row, Col } from "react-grid-system";
import { Subevent } from "../../data/Subevents";
import { usePrebookingRequest } from "../../data/PrebookingRequest";
import { usePrebookingResponse } from "../../data/PrebookingResponse";
import { CheckCircleOutlined, FieldTimeOutlined, PlusOutlined } from "@ant-design/icons";
import AddPartnerModal from "./AddPartnerModal";
import { useEvent } from "../../data/Event";


function SubeventCard({ subevent, messageApi, style }: { subevent: Subevent, messageApi: ReturnType<typeof message.useMessage>[0], style?: React.CSSProperties }) {
    const [role, setRole] = useState<number>(subevent.onlyWithPartner ? 2 : 0);
    const [partner, setPartner] = useState<number | null>(null);
    const [localLoading, setLocalLoading] = useState<boolean>(false);
    const [addPartnerModalVisible, setAddPartnerModalVisible] = useState<boolean>(false);
    const event = useEvent(state => state.event);
    const createNewPrebooking = usePrebookingRequest(state => state.createNewPrebooking);


    const prebookingRequest = usePrebookingRequest(state => state.prebooking);
    const getTrimmed = usePrebookingRequest(state => state.getTrimmed);
    const addSubeventToPrebookingRequest = usePrebookingRequest(state => state.addSubevent);
    const addPartnerToPrebookingRequest = usePrebookingRequest(state => state.addPartner);
    const removeSubeventFromPrebookingRequest = usePrebookingRequest(state => state.removeSubevent);
    const prebookingResponse = usePrebookingResponse(state => state.prebookingResponse);
    const getPrebookingResponse = usePrebookingResponse(state => state.getPrebookingResponse);
    const loading = usePrebookingResponse(state => state.loading);

    function addSubevent() {
        setLocalLoading(true);
        if (prebookingRequest) {
            addSubeventToPrebookingRequest(subevent.id ?? 0, role, partner, async (prebookingRequest: any) => {
                await getPrebookingResponse(getTrimmed(prebookingRequest), (err: any) => {
                    // Reset the prebooking request on error
                    if (err.response.data.length === 0) {
                        messageApi.error("Es ist ein Fehler aufgetreten: Unbekannter Fehler");
                    } else {
                        messageApi.error("Es ist ein Fehler aufgetreten: " + err.response.data.message);
                    }
                    createNewPrebooking(event?.id ?? 0);
                    setPartner(null)
                }, () => { });
                setLocalLoading(false);
            });
        }
    }

    function removeSubevent() {
        setLocalLoading(true);
        if (prebookingRequest) {
            removeSubeventFromPrebookingRequest(subevent.id ?? 0, async (prebookingRequest: any) => {
                await getPrebookingResponse(getTrimmed(prebookingRequest), (err: any) => {
                    if (err.response.data.length === 0) {
                        messageApi.error("Es ist ein Fehler aufgetreten: Unbekannter Fehler");
                    } else {
                        messageApi.error("Es ist ein Fehler aufgetreten: " + err.response.data.message);
                    }
                }, () => { });
                setLocalLoading(false);
            });
        }
    }

    function selectOnChange(val: any) {
        if (val === "NEW") {
            setAddPartnerModalVisible(true);
        } else {
            setPartner(val);
        }
    }

    function onModalOk(name: string, surName: string, email: string, discount: number, wsdcId: string | null, discountCode: string | null) {
        addPartnerToPrebookingRequest(name, surName, email, discount, wsdcId, discountCode, (id: number) => { setPartner(id) });
        setAddPartnerModalVisible(false);
    }

    const isSelected = prebookingResponse?.subevents.find(subeventResponse => subeventResponse.subeventId === subevent.id);
    const inQueue = prebookingResponse?.subevents.find(subeventRequest => subeventRequest.subeventId === subevent.id)?.inQueue;

    return (
        <div style={style}>
            <AddPartnerModal isOpen={addPartnerModalVisible} onOk={onModalOk} onCancel={() => setAddPartnerModalVisible(false)}></AddPartnerModal>
            <Card className={isSelected ? "selected" : ""} title={
                <Row>
                    <Col xs={6} sm={6} style={{ fontSize: "15px", textAlign: "left" }}>
                    </Col>
                    <Col xs={6} sm={6} style={{ fontSize: "20px", textAlign: "right", margin: "auto" }}>{
                        loading && localLoading ?
                            <Spin size="small"></Spin> :
                            isSelected ?
                                (inQueue ?
                                    <p style={{ color: "#F7D97F", margin: 0 }}><FieldTimeOutlined></FieldTimeOutlined> {inQueue}</p> :
                                    <p style={{ color: "#F7D97F", margin: 0 }}><CheckCircleOutlined></CheckCircleOutlined></p>

                                ) :
                                null}
                    </Col>
                </Row>}
                headStyle={{}}
                bodyStyle={{ borderTop: "1px solid white" }}
                style={{ border: "none", boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)" }}
            >
                <h2 style={{ marginTop: "0px", color: "black", marginBottom: "0px" }}>{subevent.name}</h2>
                <p style={{ color: "black", marginTop: "0px", fontStyle: "italic" }}>{subevent.description}</p>
                {
                    loading && localLoading
                        ? <Spin size="small" style={{ marginTop: "20px" }}></Spin>
                        : (
                            isSelected ?
                                <Row style={{ marginTop: "20px" }}>
                                    <Col style={{ textAlign: "center" }} sm={24}>
                                        <Button type="primary" danger onClick={removeSubevent}>Remove</Button>
                                    </Col>
                                </Row> :
                                <Row style={{ marginTop: "20px" }}>
                                    <Col sm={12} style={{ textAlign: "center", clear: "both" }}>
                                        <p style={{ margin: 0, display: !subevent.onlyWithPartner ? "block" : "none", color: "black" }}>Role:</p>
                                        <Select style={{ maxWidth: "120px", width: "100%", display: !subevent.onlyWithPartner ? "inline-block" : "none" }} value={role} onChange={val => setRole(val)}>
                                            <Select.Option value={0}>Leader</Select.Option>
                                            <Select.Option value={1}>Follower</Select.Option>
                                            <Select.Option value={2}>Couple</Select.Option>
                                        </Select>
                                        {role === 2 ?
                                            <div style={{ marginBottom: "20px" }}>
                                                <p style={{ margin: 0, marginTop: "6px", color: "black" }}>Partner:</p>
                                                <Select style={{ maxWidth: "180px", width: "100%" }} value={partner} onChange={selectOnChange}>
                                                    {prebookingRequest?.partners.map(partner => (
                                                        <Select.Option value={partner.id}>{partner.name} {partner.surName}</Select.Option>
                                                    ))}
                                                    <Select.Option value={"NEW"}><PlusOutlined /> Add partner</Select.Option>
                                                </Select>
                                            </div>
                                            : <div style={{ marginBottom: "20px" }}></div>
                                        }
                                        <Button type="primary" onClick={addSubevent} disabled={role === 2 && partner === null}>Select</Button>
                                    </Col>
                                </Row>
                        )
                }
            </Card>
        </div >
    )
}

export default SubeventCard;